import { render, staticRenderFns } from "./DocumentMain.vue?vue&type=template&id=2aa1096e&"
import script from "./DocumentMain.vue?vue&type=script&lang=js&"
export * from "./DocumentMain.vue?vue&type=script&lang=js&"
import style0 from "./DocumentMain.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aa1096e')) {
      api.createRecord('2aa1096e', component.options)
    } else {
      api.reload('2aa1096e', component.options)
    }
    module.hot.accept("./DocumentMain.vue?vue&type=template&id=2aa1096e&", function () {
      api.rerender('2aa1096e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Organizers/DocumentMain.vue"
export default component.exports